var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.contractTabs,
          expression: "contractTabs",
        },
      ],
      staticClass: "tabs",
      class: {
        contract: !_vm.advancedTabs,
        "pages-tabs": [
          "bots",
          "posts",
          "planner",
          "moderation",
          "reporting",
        ].includes(_vm.$route.name),
      },
    },
    [
      _vm._m(0),
      _c(
        "div",
        { attrs: { id: "parentx" } },
        [
          _c(
            "vs-sidebar",
            {
              staticClass: "sidebarx",
              attrs: {
                "static-position": this.static || true ? true : false,
                spacer: "",
              },
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c(
                "vs-sidebar-item",
                {
                  class: { active: !_vm.$route.name },
                  attrs: { index: "0", icon: "home" },
                  on: {
                    click: function ($event) {
                      return _vm.change(0, "overview")
                    },
                  },
                },
                [_c("a", [_vm._v("None")])]
              ),
              _c(
                "vs-sidebar-item",
                {
                  class: { active: _vm.$route.name === "overview" },
                  attrs: { index: "1", "data-qa": "nav-overview" },
                  on: {
                    click: function ($event) {
                      return _vm.change(1, "overview")
                    },
                  },
                },
                [
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        position: "right",
                        text: _vm.$t("dash.tab.overview"),
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/img/tabs/ico-overview.svg"),
                          alt: "overview",
                        },
                      }),
                      _c("a", [_vm._v(_vm._s(_vm.$t("dash.tab.overview")))]),
                    ]
                  ),
                ],
                1
              ),
              ["Admin", "Editor", "Viewer"].includes(_vm.getUserRole)
                ? _c(
                    "vs-sidebar-item",
                    {
                      class: { active: _vm.$route.name === "pages" },
                      attrs: { index: "2", "data-qa": "nav-pages" },
                      on: {
                        click: function ($event) {
                          return _vm.change(1, "pages")
                        },
                      },
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            position: "right",
                            text: _vm.$t("dash.tab.pages"),
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/tabs/ico-pages.svg"),
                              alt: "pages",
                            },
                          }),
                          _c("a", [_vm._v(_vm._s(_vm.$t("dash.tab.pages")))]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              ["Admin", "Editor"].includes(_vm.getUserRole) && _vm.getUserPlan
                ? _c(
                    "vs-sidebar-item",
                    {
                      class: { active: _vm.$route.name === "bots" },
                      attrs: { index: "3", "data-qa": "nav-bots" },
                      on: {
                        click: function ($event) {
                          return _vm.change(1, "bots")
                        },
                      },
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            position: "right",
                            text: _vm.$t("dash.tab.bots"),
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/tabs/ico-bots.svg"),
                              alt: "bots",
                            },
                          }),
                          _c("a", [_vm._v(_vm._s(_vm.$t("dash.tab.bots")))]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.version === "old" && _vm.getUserPlan
                ? [
                    _c(
                      "vs-sidebar-item",
                      {
                        class: { active: _vm.$route.name === "posts" },
                        attrs: { index: "4", "data-qa": "nav-posts" },
                        on: {
                          click: function ($event) {
                            return _vm.change(1, "posts")
                          },
                        },
                      },
                      [
                        _c(
                          "Tooltip",
                          {
                            attrs: {
                              position: "right",
                              text: _vm.$t("dash.tab.posts"),
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/tabs/ico-posts.svg"),
                                alt: "posts",
                              },
                            }),
                            _c("a", { attrs: { to: "./posts" } }, [
                              _vm._v(_vm._s(_vm.$t("dash.tab.posts"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.activePlanner && _vm.getUserPlan
                ? _c(
                    "vs-sidebar-item",
                    {
                      class: {
                        active:
                          _vm.$route.name === "planner" ||
                          _vm.$route.name === "posts2",
                      },
                      attrs: { index: "5", "data-qa": "nav-planner" },
                      on: {
                        click: function ($event) {
                          return _vm.change(1, "planner")
                        },
                      },
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            position: "right",
                            text: _vm.$t("dash.tab.scheduler"),
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/tabs/ico-planner.svg"),
                              alt: "scheduler",
                            },
                          }),
                          _c("a", { attrs: { to: "./posts" } }, [
                            _vm._v(_vm._s(_vm.$t("dash.tab.scheduler"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeModeration &&
              ["Admin", "Editor", "Writter"].includes(_vm.getUserRole) &&
              _vm.getUserPlan
                ? _c(
                    "vs-sidebar-item",
                    {
                      class: { active: _vm.$route.name === "moderation" },
                      attrs: { index: "6", "data-qa": "nav-moderation" },
                      on: {
                        click: function ($event) {
                          return _vm.change(1, "moderation")
                        },
                      },
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            position: "right",
                            text: _vm.$t("dash.tab.moderation"),
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/tabs/ico-moderation.svg"),
                              alt: "moderation",
                            },
                          }),
                          _c("a", { attrs: { to: "./posts" } }, [
                            _vm._v(_vm._s(_vm.$t("dash.tab.moderation"))),
                          ]),
                          _vm.countInboxEvents
                            ? _c("span", { staticClass: "count" }, [
                                _vm._v(_vm._s(_vm.countInboxEvents)),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeReporting &&
              ["Admin", "Editor", "Writter"].includes(_vm.getUserRole) &&
              _vm.getUserPlan
                ? _c(
                    "vs-sidebar-item",
                    {
                      class: { active: _vm.$route.name == "reporting" },
                      attrs: { index: "8", "data-qa": "nav-reporting" },
                      on: {
                        click: function ($event) {
                          return _vm.change(1, "reporting")
                        },
                      },
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            position: "right",
                            text: _vm.$t("dash.tab.reporting"),
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/tabs/ico-reporting.svg"),
                              alt: "reporting",
                            },
                          }),
                          _c("a", { attrs: { to: "./reporting" } }, [
                            _vm._v(_vm._s(_vm.$t("dash.tab.reporting"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              ["Admin", "Editor"].includes(_vm.getUserRole) && _vm.getUserPlan
                ? _c(
                    "vs-sidebar-item",
                    {
                      class: { active: _vm.$route.name == "sources" },
                      attrs: { index: "7", "data-qa": "nav-sources" },
                      on: {
                        click: function ($event) {
                          return _vm.change(1, "sources")
                        },
                      },
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            position: "right",
                            text: _vm.$t("dash.tab.sources"),
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "pink",
                            attrs: {
                              src: require("../../assets/img/tabs/ico-sources.svg"),
                              alt: "sources",
                            },
                          }),
                          _c("a", { attrs: { to: "./sources" } }, [
                            _vm._v(_vm._s(_vm.$t("dash.tab.sources"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          ["Admin", "Editor", "Writter"].includes(_vm.getUserRole)
            ? _c(
                "div",
                {
                  staticClass: "settings-wrapper",
                  class: { active: _vm.$route.name == "settings" },
                  on: {
                    click: function ($event) {
                      return _vm.change(0, "settings")
                    },
                  },
                },
                [
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        position: "right",
                        text: _vm.$t("dash.header.nav.settings"),
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "pink",
                        attrs: {
                          src: require("../../assets/img/tabs/ico-settings.svg"),
                          alt: "settings",
                        },
                      }),
                      _c("a", { attrs: { to: "./settings" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("dash.header.nav.settings")) + " "
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.applicationVersion))]),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "user-wrapper" },
            [
              _c(
                "vs-dropdown",
                {
                  attrs: {
                    "vs-custom-content": "",
                    "vs-trigger-click": "",
                    color: "#B20564",
                  },
                },
                [
                  this.userProp
                    ? _c(
                        "a",
                        {
                          staticClass: "a-icon",
                          attrs: { "href.prevent": "" },
                        },
                        [
                          !this.userProp.avatar || !this.userProp.avatar.length
                            ? _c("vs-avatar", {
                                attrs: {
                                  color: "#f9f9f9",
                                  size: "22px",
                                  src: require("../../assets/img/ico-man.svg"),
                                },
                              })
                            : _vm._e(),
                          this.userProp.avatar && !!this.userProp.avatar.length
                            ? _c("vs-avatar", {
                                attrs: { src: this.userProp.avatar },
                              })
                            : _vm._e(),
                          this.userProp.firstname && this.userProp.lastname
                            ? _c("p", { staticClass: "user-name" }, [
                                _vm._v(
                                  _vm._s(this.userProp.firstname) +
                                    " " +
                                    _vm._s(this.userProp.lastname)
                                ),
                              ])
                            : _vm._e(),
                          !this.userProp.firstname || !this.userProp.lastname
                            ? _c("p", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(_vm.$t("dash.header.myaccount"))),
                              ])
                            : _vm._e(),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("keyboard_arrow_down"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "vs-dropdown-menu",
                    { staticClass: "loginx" },
                    [
                      ["Admin", "Editor", "Writter"].includes(_vm.getUserRole)
                        ? _c(
                            "vs-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.change(0, "settings")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "dropdown-item" }, [
                                _c("a", [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/img/header/nav/ico-gear.svg"),
                                      alt: "settings",
                                    },
                                  }),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.header.nav.settings")
                                      ) + " "
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.applicationVersion)),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.change(0, "invoice")
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "dropdown-item" }, [
                            _c("a", [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/header/nav/ico-invoice.svg"),
                                  alt: "invoice",
                                },
                              }),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.header.nav.invoice"))
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _c("vs-dropdown-item", [
                        _c("div", { staticClass: "dropdown-item" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "mailto:contact@mashup-web.com" },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/header/nav/ico-support.svg"),
                                  alt: "support",
                                },
                              }),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.header.nav.support"))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm.pwaInstalled
                        ? _c("vs-dropdown-item", [
                            _c("div", { staticClass: "dropdown-item" }, [
                              _c("a", { on: { click: _vm.installPwa } }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/header/nav/pwa-install.svg"),
                                    alt: "application",
                                  },
                                }),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.$t("dash.header.nav.pwa"))),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.change(0, "logout")
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "dropdown-item" }, [
                            _c("a", [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/header/nav/log-out.svg"),
                                  alt: "logout",
                                },
                              }),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.header.nav.logout"))
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "language-wrapper" },
            [
              _c(
                "vs-dropdown",
                {
                  attrs: {
                    "vs-custom-content": "",
                    "vs-trigger-click": "",
                    color: "#B20564",
                  },
                },
                [
                  _c(
                    "a",
                    { staticClass: "a-icon", attrs: { "href.prevent": "" } },
                    [
                      _c("p", { staticClass: "locale" }, [
                        _vm._v(_vm._s(this.$i18n.locale)),
                      ]),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("keyboard_arrow_down"),
                      ]),
                    ]
                  ),
                  _c(
                    "vs-dropdown-menu",
                    { staticClass: "select-lang" },
                    _vm._l(_vm.locales, function (lang) {
                      return _c(
                        "vs-dropdown-item",
                        {
                          key: lang,
                          class: lang,
                          on: {
                            click: function ($event) {
                              return _vm.changeLocale(lang)
                            },
                          },
                        },
                        [_c("p", [_vm._v(_vm._s(lang))])]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vs-prompt",
        {
          staticClass: "prompt-remove-posts",
          attrs: {
            color: "#6a1f4c",
            "cancel-text": _vm.$t(
              "dash.posts.disclaimer-post.change-tab.prompt.btn-cancel"
            ),
            "accept-text": _vm.$t(
              "dash.posts.disclaimer-post.change-tab.prompt.btn-continue"
            ),
            title: _vm.$t("dash.posts.disclaimer-post.change-tab.prompt.title"),
            active: _vm.showDisclaimerPost,
          },
          on: {
            close: _vm.closeDisclaimerPost,
            cancel: _vm.closeDisclaimerPost,
            accept: function ($event) {
              return _vm.change(_vm.savedUpdate.index, _vm.savedUpdate.section)
            },
            "update:active": function ($event) {
              _vm.showDisclaimerPost = $event
            },
          },
        },
        [
          _c("div", { staticClass: "con-exemple-prompt" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("dash.posts.disclaimer-post.change-tab.prompt.content")
                ) +
                "          \n      "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo-wrapper" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("../../assets/img/logo_mw_social_white_small.png"),
          alt: "Mashup logo",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }